import { MoreOutlined } from '@ant-design/icons';
import { Badge, Button, Checkbox, Col, Divider, Input, Layout, List, message, Modal, Popover, Radio, Row, Select, Space, Spin, Upload } from "antd";
import React, { useEffect, useState } from "react";
import LayoutHeader from "../../layouts/partials/LayoutHeader";
import { apiCall } from "../../utils/Api";
import PublisherCard from './PublisherCard';
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import PublisherRow from './PublisherRow';
import { pluralize } from '../../utils/Utils';
import Html from '../../utils/Html';
import TitleResults from '../../components/title/TitleResults';
import Session, { useSession } from '../../utils/Session';
import TextArea from 'antd/lib/input/TextArea';


export default function PublisherISBNUploadFilter(props) {

    const { filters = {}, setFilters = () => { } } = props;

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [pastedText, setPastedText] = useState("");
    const [uploading, setUploading] = useState(false);
    const [count, setCount] = useState(0);

    const handleUpload = (file) => {
        uploadFile(file);
        return false; // prevent default upload behavior
    };

    const uploadFile = (_file) => {
        setUploading(true);
        apiCall("browse/getCacheKeyForFile", { file: _file }, (_status, _result) => {
            if (_status) {
                setFilters({ ...filters, "custom_isbn_filter_id": _result.id });
                setCount(_result.count)
            } else {
                message.error(_result.error)
            }
            setUploading(false);
            setIsModalOpen(false)

        });
    };

    const handleSaveText = () => {
        if (!pastedText.trim()) {
            message.warning("Please paste some text first.");
            return;
        }

        const blob = new Blob([pastedText], { type: "text/plain" });
        const file = new File([blob], "isbns.txt", { type: "text/plain" });

        uploadFile(file);
    };



    // if(filters?.custom_isbn_filter_id){
    //     return(<div onClick={() => setFilters({...filters, "custom_isbn_filter_id" : ""})}>Remove</div>)
    // }

    return (
        <>
            <div className='shim' />

            <div className='float-flex'>
                <div>
                    <Button size="small" onClick={() => setIsModalOpen(true)}>
                        <small>Search by ISBNS</small>
                    </Button>
                </div>

                {(filters?.custom_isbn_filter_id &&
                    <Space>
                        <div>{count} ISBNs</div>
                        <Button onClick={() => setFilters({ ...filters, "custom_isbn_filter_id": "" })} size="small">
                            <small>Clear</small>
                        </Button>
                    </Space>
                )}

            </div>


            <Modal

                visible={isModalOpen}
                onCancel={() => setIsModalOpen(false)}
                footer={null}
            >
                <Space direction="vertical" style={{ width: "100%" }} >
                    <div>
                        <strong>Custom ISBN Filter</strong>
                        <Divider dashed />

                        <p style={{ "lineHeight": "16px" }}>Search results will have a filter applied to only consider these ISBNs. Maximum 100,000 allowed</p>

                        <p style={{ "lineHeight": "16px" }}>A text file with one ISBN per row, or an XLS/XLSX file with a column labelled "ISBN"</p>
                        <Space>
                            <div>Upload file:</div>
                            <Upload
                                beforeUpload={handleUpload}
                                accept=".txt, .xls, .csv, .tsv, .xlsx"
                                showUploadList={false}
                                disabled={uploading}
                            >
                                <Button size='small' loading={uploading} type="primary" block>
                                    <small>Chose File...</small>
                                </Button>
                            </Upload>
                        </Space>
                    </div>

                    <Divider style={{ "margin": "10px 0px" }} plain><small>OR</small></Divider>
                    <div>
                        {/* <p style={{ "lineHeight": "16px" }}>Paste up to 100,000 ISBNs into the text box.</p> */}
                        Paste up to 100,000 ISBNs into the text box
                        <TextArea
                            rows={6}
                            value={pastedText}
                            onChange={(e) => setPastedText(e.target.value)}
                            placeholder="Paste ISBNs here, one per line..."
                        />
                        <div className='shim' /><div className='shim' /><div className='shim' /><div className='shim' />
                        <div className='float-flex'>
                            <div></div>
                            <div>
                                <Space>
                                    <Button onClick={() => setIsModalOpen(false)}><small>Cancel</small></Button>
                                    <Button
                                        onClick={handleSaveText}
                                        loading={uploading}
                                        type="primary"

                                    >
                                        <small>Save Text</small>
                                    </Button>
                                </Space>
                            </div>
                        </div>
                    </div>
                </Space>
            </Modal>
        </>
    );
}